import { EVENT_TYPES } from './event-types'

export default {
  ID_VERIFICATION_KSA_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__page_viewed',
  },
  ID_VERIFICATION_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification__start_clicked',
  },
  ID_VERIFICATION_NATIONAL_IQAMA_ID_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__national_id_iqama_interacted',
  },
  ID_VERIFICATION_BIRTHDAY_DATE_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__birthday_date_interacted',
  },
  ID_VERIFICATION_BIRTHDAY_MONTH_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__birthday_month_interacted',
  },
  ID_VERIFICATION_BIRTHDAY_YEAR_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__birthday_year_interacted',
  },
  ID_VERIFICATION_CONTINUE_VERIFICATION_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__verificiation_continue_clicked',
  },
  ID_VERIFICATION_RETRY_LIMIT_REACHED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__retry_limit_reached',
  },
  ID_VERIFICATION_SKIP_NAFATH_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__skip_nafath_clicked',
  },
  ID_VERIFICATION_NAFATH_VERIFICATION_STATUS: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_verification_status_polling',
  },
  ID_VERIFICATION_NAFATH_SUCCESS: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_success',
  },
  ID_VERIFICATION_NAFATH_RETRY_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_retry_clicked',
  },
  ID_VERIFICATION_NAFATH_ERROR_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_error_recoverable_screen_viewed',
  },
  ID_VERIFICATION_OTP_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__otp_page_viewed',
  },
  ID_VERIFICATION_WHERE_TO_FIND_IQAMA_POPUP_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__where_to_find_iqama_popup_viewed',
  },
  ID_VERIFICATION_WHERE_TO_FIND_IQAMA_POPUP_CLOSED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__where_to_find_iqama_popup_close_clicked',
  },
  ID_VERIFICATION_WHY_AM_I_ASKED_POPUP_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__why_need_id_popup_viewed',
  },
  ID_VERIFICATION_WHY_AM_I_ASKED_POPUP_CLOSED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__why_need_id_popup_close_clicked',
  },

  ID_VERFICATION_NAFATH_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__nafath_viewed',
  },
  ID_VERFICATION_NAFATH_HOW_IT_WORKS_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_how_does_it_works_clicked',
  },
  ID_VERFICATION_NAFATH_DOWNLOAD_NAFATH_APP_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_download_nafath_app_clicked',
  },
  ID_VERFICATION_NAFATH_OPEN_NAFATH_APP_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_open_nafath_app_clicked',
  },
  ID_VERFICATION_NAFATH_SUCCESSFUL_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_successful_viewed',
  },
  ID_VERFICATION_NAFATH_FAILED_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_failed_viewed',
  },
  ID_VERIFICATION_CREDIT_EVALUATION_WAITING_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__credit_evaluation_waiting_page_viewed',
  },
  ID_VERIFICATION_KYC_APPROVED_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__kyc_approved_page_viewed',
  },
  ID_VERFICATION_NAFATH_FAILED_POPUP_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__nafath_failed_popup_viewed',
  },
  ID_VERFICATION_UQUDO_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_uae__uqudo_page_viewed',
  },
  ID_VERFICATION_UQUDO_INITIALIZING: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_initiated_viewed',
  },
  ID_VERFICATION_UQUDO_ERROR_OCCURED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_sdk_submit_error_occured',
  },
  ID_VERFICATION_UQUDO_SDK_ERROR_OCCURED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_sdk_error_occured',
  },
  ID_VERFICATION_UQUDO_REJECTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_sdk_submit_failed',
  },
  ID_VERFICATION_UQUDO_SUCCESS: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_sdk_submit_success',
  },
  ID_VERFICATION_SIGNZY_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_uae__signzy_page_viewed',
  },
  ID_VERFICATION_SIGNZY_RETAKE_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__signzy_retake_button_clicked',
  },
  ID_VERFICATION_SIGNZY_UPLOAD_IMAGE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__signzy_upload_id_image_clicked',
  },
  ID_VERFICATION_SIGNZY_ID_IMAGE_UPLOADED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__signzy_upload_id_image_uploaded',
  },
  ID_VERFICATION_SIGNZY_ID_IMAGE_SELECTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__signzy_id_image_select_clicked',
  },
  ID_VERFICATION_SIGNZY_ID_IMAGE_SUBMIT_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__signzy_id_image_submit_button_clicked',
  },
  ID_VERFICATION_SIGNZY_ID_IMAGE_CAPTURED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__signzy_id_image_captured_viewed',
  },
  ID_VERFICATION_SIGNZY_ID_CHANGE_PHOTO_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__signzy_id_change_photo_clicked',
  },
  ID_VERFICATION_SIGNZY_CANCEL_UPLOAD_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__signzy_cancel_upload_clicked',
  },
  ID_VERFICATION_WRONG_ID_IQAMA_ERROR_SHOWN: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'idverification_ksa__nationalid_iqamanumber_inline_error_viewed',
  },
  ID_VERFICATION_DOB_ERROR_SHOWN: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__birthday_format_inline_error_viewed',
  },
  ID_VERFICATION_ID_IQAMA_MISSING_ERROR_SHOWN: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__card_missing_info_error_viewed',
  },
  ID_VERFICATION_DOB_MISSING_ERROR_SHOWN: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_ksa__dob_missing_info_error_viewed',
  },
  ID_VERFICATION_UQUDO_CAMERA_ACCESS_TRY_AGAIN: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_try_again_camera_access_clicked',
  },
  ID_VERFICATION_UQUDO_SESSION_TIMEOUT_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_session_timeout_viewed',
  },
  ID_VERFICATION_UQUDO_SESSION_TIMEOUT_RETURN_TO_CHECKOUT_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME:
      'idverification_uae__uqudo_session_timeout_return_to_checkout_clicked',
  },
  ID_VERFICATION_UQUDO_FAILED_TRY_AGAIN_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_failed_try_again_clicked',
  },
  ID_VERFICATION_UQUDO_FACE_VERIFICATION_SUCCESS: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_face_verification_success',
  },
  ID_VERFICATION_UQUDO_CANCEL_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_cancel_clicked',
  },
  ID_VERFICATION_UQUDO_BACK_TO_CHOOSE_PLAN_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uqudo_back_to_choose_plan_clicked',
  },

  // UAE KYC (web SDK) tracking
  ID_VERIFICATION_UAE_KYC_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_uae__uaekyc_page_viewed',
  },
  ID_VERIFICATION_UAE_KYC_INITIATED_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uaekyc_initiated_viewed',
  },
  ID_VERIFICATION_UAE_KYC_SDK_ERROR_OCCURED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uaekyc_sdk_error_occured',
  },
  ID_VERIFICATION_UAE_KYC_SDK_SUBMIT_FAILED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uaekyc_sdk_submit_failed',
  },
  ID_VERIFICATION_UAE_KYC_SDK_SUBMIT_SUCCESS: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'idverification_uae__uaekyc_sdk_submit_success',
  },
  KYC_FAILURE_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__kyc_failure_page_viewed',
  },
  KYC_DECLINED_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__kyc_declined_page_viewed',
  },
  KYC_FINISH_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__kyc_finish_page_viewed',
  },
  KYC_CREDIT_UNDERWRITING_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__kyc_credit_underwriting_page_viewed',
  },
  ID_VERFICATION_ERROR_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'idverification_ksa__error_page_viewed',
  },
  ID_VERIFICATION_NOVA_QUESTIONAIRE_QUESTION_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'nova_questionaire_question__X__viewed',
  },
  ID_VERIFICATION_QUESTIONAIRE_STARTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'questionaire_started',
  },
  QUESTION_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'question_viewed',
  },
  QUESTIONNAIRE_ANSWERED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'questionnaire_answered',
  },
  ID_VERIFICATION_NOVA_QUESTIONAIRE_QUESTION_ANSWERED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'nova_questionaire_question__X__answered',
  },
  ID_VERIFICATION_NOVA_QUESTIONAIRE_QUESTION_CONTINUE_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'nova_questionaire_question__X__continue_clicked',
  },
  ID_VERIFICATION_NOVA_QUESTIONAIRE_ANSWERS_SUBMITTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'nova_questionaire_answers_submitted',
  },
  ID_VERIFICATION_NOVA_QUESTIONAIRE_QUICK_SELECT_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'nova_questionaire_quick_select_clicked',
  },
  UAE_KYC_BUTTON_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'uae_kyc_button_clicked',
  },
}
